/** Planos.studio – Interactive spatial map & floorplan platform */
import type { HotspotIcon } from './types';

export const APP_NAME = 'Planos.studio';
export const APP_VERSION = '1.0.0';

export const PLANOS_TAGLINE =
  'Overlay floor plans on Google Maps, add camera hotspots with real photos, and publish interactive spatial maps.';

export const PLANOS_FEATURES = [
  { title: 'Map + Floor Plan Overlay', description: 'Place your floor plan on Google Maps at the exact GPS coordinates. Zoom in to see the detail.' },
  { title: 'Camera Hotspots', description: 'Drop camera markers on the plan, attach real photos, and set the viewing direction with radar cones.' },
  { title: 'Zoom-Sync Transition', description: 'As you zoom in, the map fades into your high-detail floor plan seamlessly.' },
  { title: 'Interactive Viewer', description: 'Publish a link where viewers click hotspots to see photos in animated pop-ups.' },
  { title: 'Room Navigation', description: 'Sidebar room list lets viewers jump between hotspots with smooth map panning.' },
  { title: '360° Pano Upload', description: 'Upload 360° panoramas and attach them to hotspots for immersive, full-sphere viewing in the interactive map.' },
];

/** Planos brand palette */
export const PLANOS_PRIMARY = '#FF3B30';
export const PLANOS_SECONDARY = '#8E0000';
export const PLANOS_SURFACE = '#2F2F2F';
export const PLANOS_NEUTRAL = '#F5F5F5';

/** Default map center (London) */
export const DEFAULT_COORDS = { lat: 51.5074, lng: -0.1278 };

/** Preset marker colours so users can visually differentiate hotspot types. */
export const HOTSPOT_COLORS: { value: string; label: string }[] = [
  { value: '#FF3B30', label: 'Red' },
  { value: '#FF9500', label: 'Orange' },
  { value: '#FFCC00', label: 'Yellow' },
  { value: '#34C759', label: 'Green' },
  { value: '#00C7BE', label: 'Teal' },
  { value: '#007AFF', label: 'Blue' },
  { value: '#5856D6', label: 'Indigo' },
  { value: '#AF52DE', label: 'Purple' },
  { value: '#FF2D55', label: 'Pink' },
  { value: '#8E8E93', label: 'Grey' },
];

/** Hotspot icon options for markers. 'camera' is the default; 'custom' = client's own image. */
export const HOTSPOT_ICONS: { type: HotspotIcon; label: string }[] = [
  { type: 'camera', label: 'Photo (default)' },
  { type: 'pano360', label: '360° Panorama' },
  { type: 'custom', label: 'Custom' },
  { type: 'file', label: 'PDF / File' },
  { type: 'video', label: 'Video' },
  { type: 'map-pin', label: 'Location' },
  { type: 'home', label: 'Room' },
];
